import { render, staticRenderFns } from "./ShowFormula.vue?vue&type=template&id=a578454e"
import script from "./ShowFormula.vue?vue&type=script&lang=js"
export * from "./ShowFormula.vue?vue&type=script&lang=js"
import style0 from "./ShowFormula.vue?vue&type=style&index=0&id=a578454e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports